<!--模板-->
<template>
  <div id="agreement">
    <div>
      <el-dialog :visible.sync="Show"   width="50%">
        <div v-html="tcpData.content"></div>
      </el-dialog>
    </div>
  </div>
</template>


<!--JS-->
<script>
  import {serverProCont,moveTu} from 'api/apis'
  export default {
    props:{
      tcpId:'',
      textShow:false
    },
    data() {
      return {
        Show:false,
        tcpData:''
      };
    },
    watch:{
      textShow(){
        let vm = this
        vm.Show = true
        console.log(this.tcpId,"12222222222")
        let params ={
          id:vm.tcpId
        }
        serverProCont({params}).then((res)=>{
          if(res.code == '000000'){
            vm.tcpData = res.data
          }
        })
      }
    },
    methods:{

    },
    mounted() {


    }
  };
</script>


<!--css样式-->
<style lang="scss" scoped>
  @import '../../../src/scss/commonH5.scss';
  @import '../../scss/demo.scss';
  #agreement{
    width: 100%;
  }


</style>



// WEBPACK FOOTER //
// src/components/common/tcp.vue